import React, { useEffect } from "react";
import Home from "pages/Home";
import { Route, Routes } from "react-router-dom";
import LandingPage from "pages/Landingpage";
import Signin from "pages/Signin";
import Signup from "pages/Signup";
import IndexNavbar from "components/Navbars/IndexNavbar";
import AddInfo from "pages/AddInfo";
import AdminLogin from "admin/AdminLogin";
import UploadProfile from "pages/UploadProfile";
import ForgotPassword from "pages/ForgotPassword";
import ChargeAmount from "pages/ChargeAmount";

import Payment from "pages/Payment";

import { useNavigate } from "react-router-dom";
import { store } from "reactStore/MainStore";
import IsLogin from "./IsLogin";
function Main() {
  let navigate = useNavigate();

  return (
    <>
      {/* <IndexNavbar /> */}
      <main>
        <section className='relative w-full py-18 h-full  min-h-screen '>
          <Routes>
            {/*             
            <Route path='/main' element={<LandingPage />} />
            <Route path='/' element={<Signin />} />
            <Route path='/signup' element={<Signup />} />
            <Route path='/home' element={<Home />} />
            <Route path='/addinfo' element={<AddInfo />} />
            <Route path='/uploadprofile' element={<UploadProfile />} />
            <Route path='adminlogin' element={<AdminLogin />} />
            <Route path='/forgotpassword' element={<ForgotPassword />} /> */}
            <Route path='/' element={<Payment />} />
          </Routes>
        </section>
      </main>
    </>
  );
}

export default Main;
